// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f29ed28","667":"ff239537"}[chunkId] + ".chunk.js";
};